<template>
  <device-wrapper #default="{ desktop }">

    <template v-if="desktop">
      <van-popup v-model:show="model" :close-icon-position="$i18n.locale === 'en' ? 'top-right' : 'top-left'"
                 :style="{ maxWidth: getWidthBySize, minWidth: getWidthBySize, borderRadius: '10px' }"
                 class="p-4"
                 v-bind="$attrs" @opened="emit('opened')"
                 @click-overlay="emit('close')" @click-close-icon="emit('close')">
        <div class="flex flex-col justify-between h-full">
          <slot name="title">
            <div class="font-niceone-medium text-[16px] mb-6">{{ title }}</div>
          </slot>

          <slot/>

          <slot name="action-button">
            <van-button v-if="!hideActionBtn" block type="primary" v-bind="btnProps" @click="emit('submit')">
              {{ btnText }}
            </van-button>
          </slot>
        </div>
      </van-popup>
    </template>

    <template v-else>
      <van-popup v-model:show="model" :close-icon-position="$i18n.locale === 'en' ? 'top-right' : 'top-left'"
                 class="p-3" position="bottom"
                 v-bind="$attrs" @opened="emit('opened')"
                 @click-overlay="emit('close')" @click-close-icon="emit('close')">
        <div class="flex flex-col justify-between h-full">

          <div class="h-full">
            <slot name="title">
              <div class="font-niceone-medium text-[16px] mb-3">{{ title }}</div>
            </slot>

            <slot/>
          </div>

          <slot name="action-button">
            <van-button v-if="!hideActionBtn" block type="primary" v-bind="btnProps" @click="emit('submit')">
              {{ btnText }}
            </van-button>
          </slot>
        </div>
      </van-popup>
    </template>

  </device-wrapper>
</template>

<script setup>
const props = defineProps({
  modelValue: {
    type: Boolean,
    default: false
  },
  size: {
    type: String,
    default: "sm" // sm || md || lg
  },
  title: {
    type: String,
    default: ""
  },
  btnText: {
    type: String,
    default: ""
  },
  btnProps: {
    type: Object,
    default: () => {
    }
  },
  hideActionBtn: {
    type: Boolean,
    default: false
  }
})

const emit = defineEmits(['update:modelValue', 'submit', 'close', 'opened'])

const model = computed({
  get() {
    return props.modelValue
  },
  set(val) {
    emit('update:modelValue', val)
  }
})

const getWidthBySize = computed(() => {
  switch (props.size) {
    case 'sm': {
      return '350px'
    }
    case 'md': {
      return '500px'
    }
  }
})
</script>
